import { PureComponent } from 'react';
import PropTypes from 'prop-types';

// { "class-name": [componentObjectRefs...] }
const classReferences = {};

class RootClasses extends PureComponent {
  updateClasses(className) {
    const classes = !className
      ? []
      : Array.isArray(className)
      ? className.map(c => c.toLowerCase())
      : className.toLowerCase().split(' ');
    const addedClasses = new Set();
    classes.forEach(c => {
      if (c && (!classReferences[c] || !classReferences[c].has(this))) {
        addedClasses.add(c);
      }
    });

    // Add new classes to refs
    addedClasses.forEach(c => {
      let refs = classReferences[c];
      if (!refs) {
        refs = classReferences[c] = new Set();
        document.documentElement.classList.add(c);
        document.body.classList.add(c);
      }
      refs.add(this);
    });

    // Remove missing classes from refs
    for (const c in classReferences) {
      const refs = classReferences.hasOwnProperty(c) && classReferences[c];
      if (refs && refs.has(this) && classes.indexOf(c) === -1) {
        refs.delete(this);
        if (!refs.size) {
          document.documentElement.classList.remove(c);
          document.body.classList.remove(c);
          delete classReferences[c];
        }
      }
    }
  }

  componentDidMount() {
    this.updateClasses(this.props.className);
  }

  componentDidUpdate() {
    this.updateClasses(this.props.className);
  }

  componentWillUnmount() {
    this.updateClasses(null);
  }

  render() {
    return null;
  }
}

RootClasses.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired
};

export default RootClasses;
